<section class="cmspage mtb-40">
        <div class="container">
          <div class="error-404">
            <h1>404</h1>
            <h2>¡Aquí no hay nada!</h2>
            <p>Lo siento, debes haberte equivocado porque la página que buscas no existe</p>
            <button (click)="goHome()" class="btn btn-danger">Volver al inicio</button>
          </div>
        </div>
      </section>
      